var _defs, _rect, _g, _g2, _path, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNecaVic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "New_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 431.48 133.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#004f9f;}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 344.96,
    y1: 2.78,
    x2: 344.96,
    y2: 129.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004f9f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.15,
    width: 1.7,
    height: 133.56
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 102.91,
    cy: 59.68,
    rx: 102.91,
    ry: 6.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 102.91,
    cy: 8.71,
    rx: 102.91,
    ry: 6.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 102.91,
    cy: 34.6,
    rx: 102.91,
    ry: 6.78
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.28,96.39H9.12v36.47h9.64v-28.41h7.75c5.48,0,6.37,1.45,6.37,6.5v21.91h9.64v-23.09c0-9.7-4.44-13.38-15.25-13.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.61,114.67c0,11.97,6.23,18.2,18.36,18.2h14.07v-7.62h-12.82c-6.24,0-8.73-.75-8.94-6.78h21.76v-7.61h-21.76c.21-5.83,2.84-6.87,9.01-6.87h12.75v-7.61h-14.07c-12.13,0-18.36,6.37-18.36,18.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.51,100.75c-3.39,3.25-5.39,8.31-5.39,14.07s2.08,10.47,5.39,13.7c3.39,3.32,7.68,4.35,13.71,4.35h13.09v-7.8h-10.26c-3.25,0-5.68,0-7.62-1.18-2.98-1.8-4.3-4.71-4.3-9.08,0-8.46,3.67-10.54,11.92-10.54h10.26v-7.89h-13.09c-6.03,0-10.33,1.11-13.71,4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.78,125.53h-12.09c-3.54,0-5.28-.42-5.28-3.49,0-3.28,1.87-4.12,5.97-4.12h11.4v7.61Zm-5.14-29.15h-19.74v7.52h16.06c6.12,0,8.75,1.24,8.75,5.88v.9h-12.71c-10.18,0-14.52,3.17-14.52,11.64,0,6.75,4,10.55,11.25,10.55h25.96v-22.88c0-8.98-5.05-13.6-15.05-13.6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269,0h162.48V123c0,5.83-4.73,10.56-10.56,10.56h-162.48V10.56c0-5.83,4.73-10.56,10.56-10.56Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.13,45.71l11.48,29.95h.22l11.86-29.95h11.27l-19.17,42.14h-9.15l-17.82-42.14h11.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.66,87.85V45.71h10.4v42.14h-10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.11,87.85h-17.82c-5.71,0-10.04-1.81-13-5.42-2.96-3.61-4.44-8.83-4.44-15.65s1.48-12.04,4.44-15.65c2.96-3.61,7.29-5.42,13-5.42h17.82v8.99h-15.22c-3.03,0-5.25,1.06-6.63,3.17-1.39,2.11-2.09,5.08-2.09,8.91s.69,6.8,2.09,8.91c1.39,2.11,3.6,3.17,6.63,3.17h15.22v8.99Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNecaVic);
export default __webpack_public_path__ + "static/media/NECA-VIC.d9ed0d62b7f0c086543fad361bd46edb.svg";
export { ForwardRef as ReactComponent };